
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 0a5.969 5.969 0 00-3.675 1.264L1.309.25C1.018-.044.522-.065.23.229c-.293.292-.273.788.02 1.08l1.015 1.016A5.968 5.968 0 000 6a6 6 0 106-6zm0 9a3 3 0 01-3-3c0-.555.161-1.07.424-1.515l1.132 1.131c-.033.123-.056.25-.056.384A1.5 1.5 0 106 4.5c-.133 0-.26.023-.384.056L4.485 3.425C4.93 3.16 5.445 3 6 3a3 3 0 010 6z"}})])
          )
        }
      }
    